import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { type TypeFilterProps } from '~/components/Filters/TypeFilter/TypeFilter';
import { TYPE_FILTERS } from '~/components/Filters/types';
import {
  addAssetFileKindFilterValueAction,
  addItemTypeFilterAction,
  addMultipleAssetFileKindFilterValuesAction,
  removeAssetFileKindFilterValueAction,
  removeItemTypeFilterAction,
  removeMultipleAssetFileKindFilterValuesAction,
} from '~/store/filters/actions';
import { selectedItemTypesFiltersSelector } from '~/store/filters/selectors';

export const useTypeFilterUpdate = () => {
  const dispatch = useDispatch();
  const selectedTypes = useSelector(selectedItemTypesFiltersSelector);

  const onTypeSelectedChange = useCallback<TypeFilterProps['onTypeSelectedChange']>(
    ({ type, isSelected }) => {
      dispatch(
        removeMultipleAssetFileKindFilterValuesAction({
          assetFileKinds: Object.values(TYPE_FILTERS[type].subFilters ?? {}).map((subFilter) => subFilter.id),
        }),
      );

      if (isSelected) {
        dispatch(addItemTypeFilterAction({ type }));
      } else {
        dispatch(removeItemTypeFilterAction({ type }));
      }
    },
    [dispatch],
  );

  const onAssetFileKindSelectedChange = useCallback<TypeFilterProps['onAssetFileKindSelectedChange']>(
    ({ assetFileKind, type, isSelected }) => {
      const isTypeSelected = selectedTypes.includes(type);

      if (isTypeSelected) {
        dispatch(removeItemTypeFilterAction({ type }));
      }

      if (isTypeSelected && !isSelected) {
        dispatch(
          addMultipleAssetFileKindFilterValuesAction({
            assetFileKinds: Object.values(TYPE_FILTERS[type].subFilters ?? {}).map((subFilter) => subFilter.id),
          }),
        );
      }

      if (isSelected) {
        dispatch(addAssetFileKindFilterValueAction({ assetFileKind }));
      } else {
        dispatch(removeAssetFileKindFilterValueAction({ assetFileKind }));
      }
    },
    [dispatch, selectedTypes],
  );

  return {
    onAssetFileKindSelectedChange,
    onTypeSelectedChange,
  };
};
